import React, { useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Input from 'components/Input/Input';

export interface IPasswordInputIconAction {
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

interface IPasswordInputProps {
  label?: string;
  value: string;
  iconActions?: IPasswordInputIconAction[];
}

export const PasswordInput: React.FC<IPasswordInputProps> = ({
  label,
  value,
  iconActions = []
}) => {
  const [showValue, setShowValue] = useState(false);

  const toggleVisibility = (): void => setShowValue(!showValue);
  const actions = [
    {
      icon: showValue ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye',
      onClick: toggleVisibility
    },
    ...iconActions
  ];

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className={'text-sm font-medium text-gray-700'}>{label}</label>
      )}
      <Input
        value={value}
        disabled
        type={showValue ? 'text' : 'password'}
        inputClassName="!pr-20"
        rightIcon={
          <div className="flex items-center gap-2">
            {actions.map((action) => (
              <div
                key={action.icon}
                className={`flex h-6 w-6 items-center justify-center rounded-md p-1 ${action.disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer hover:bg-base-accent'}`}
                onClick={action.disabled ? undefined : action.onClick}
              >
                <FontAwesomeIcon
                  icon={action.icon}
                  className={`h-4 w-4 ${action.className || ''}`}
                />
              </div>
            ))}
          </div>
        }
        rightIconStyles="absolute right-0 top-1/2 flex w-max -translate-y-1/2 items-center gap-0 text-base-mutedForeground"
      />
    </div>
  );
};
